var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24ZM4.8 24C4.8 13.3961 13.3961 4.8 24 4.8C34.6039 4.8 43.2 13.3961 43.2 24C43.2 34.6039 34.6039 43.2 24 43.2C13.3961 43.2 4.8 34.6039 4.8 24Z",
    fill: "#C2C5C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.8555C25.0196 12.8555 25.861 13.6184 25.9844 14.6046L26 14.8555V25.1412C26 26.2458 25.1046 27.1412 24 27.1412C22.9804 27.1412 22.139 26.3782 22.0156 25.3921L22 25.1412V14.8555C22 13.7509 22.8954 12.8555 24 12.8555Z",
    fill: "#C2C5C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C25.0196 30 25.861 30.763 25.9844 31.7491L26 32V33C26 34.1046 25.1046 35 24 35C22.9804 35 22.139 34.237 22.0156 33.2509L22 33V32C22 30.8954 22.8954 30 24 30Z",
    fill: "#C2C5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ce1298d300ed1ba3af0618471499e588.svg";
export { ForwardRef as ReactComponent };